type ModulesConfigElem = {
	moduleName: string;
	moduleCategory?: string;
	moduleWeight?: number;
	moduleOrder?: number;
};

const matchesKey = (
	moduleName: string,
	key: string,
	aliasList: string[] = [],
) =>
	moduleName === key ||
	moduleName.endsWith(`_${key}`) ||
	moduleName.includes(key) ||
	aliasList.some((a) => moduleName.includes(a));

const defaultAliases: Record<string, string[]> = {
	dialog: ["chat_window"],
	chat_window: ["dialog"],
};

/**
 * Обновляет moduleOrder в localStorage "modulesConfig" согласно новому порядку paneKeys.
 * paneKeys — массив ключей панелей в их новом порядке (индекс = новый moduleOrder - 1).
 */
export const updateModuleOrder = (paneKeys: string[]): void => {
	if (typeof window === "undefined") return;
	if (!paneKeys || paneKeys.length === 0) return;

	try {
		const raw = localStorage.getItem("modulesConfig");
		let parsed: ModulesConfigElem[] = [];
		try {
			parsed = raw ? (JSON.parse(raw) as ModulesConfigElem[]) : [];
		} catch {
			parsed = [];
		}

		const updated = parsed.map((cfg) => ({ ...cfg }));

		paneKeys.forEach((key, i) => {
			const aliasList = defaultAliases[key] ?? [];
			const idx = updated.findIndex(
				(c) => c && c.moduleName && matchesKey(c.moduleName, key, aliasList),
			);
			if (idx !== -1) {
				updated[idx].moduleOrder = i + 1;
			}
		});

		localStorage.setItem("modulesConfig", JSON.stringify(updated));
	} catch (err) {
		console.warn("updateModuleOrder failed", err);
	}
};

export default updateModuleOrder;
